import { AxiosRequestConfig } from "axios";
import { QueryParamsForGetRequest } from "@/utils/types";
import { appendQueryToUrl } from "@/utils";
import {
  AddSubContractorPayload,
  AddSubContractorResponse,
  getAddContractorEndpoint,
  getCreateSubContractorEndpoint,
  getDeleteContractorEndpoint,
  getSubContractorByNameEndpoint,
  getSubContractorsEndpoint,
  getUpdateSubContractorEndpoint,
  SubContractor,
  SubContractorsFlatResponse,
  SubContractorsResponseSchema,
  SubContractorsSearchResponse,
  SubContractorsSearchResponseSchema,
  UpdateContractorResponse,
  UpdateCreateSubContractorPayload,
} from "@/services/api";
import { http } from "@/services";

export const requestSubcontractor = (
  { email }: { email: string },
  config?: AxiosRequestConfig,
) => {
  return http.get<SubContractor[]>(
    getSubContractorsEndpoint,
    { email },
    config,
    undefined,
  );
};

export const requestCreateSubcontractor = (
  email: QueryParamsForGetRequest,
  data: UpdateCreateSubContractorPayload,
  config?: AxiosRequestConfig,
) => {
  const url = appendQueryToUrl(getCreateSubContractorEndpoint, email);

  return http.post<SubContractor>(url, { ...data }, config);
};

export const requestUpdateSubcontractor = (
  email: QueryParamsForGetRequest,
  data: UpdateCreateSubContractorPayload,
  config?: AxiosRequestConfig,
) => {
  const url = appendQueryToUrl(getUpdateSubContractorEndpoint, email);

  const finalData: UpdateCreateSubContractorPayload = {
    ...data,
    AdcciMembershipNo: data.AdcciMembershipNo || null,
  };

  return http.put<UpdateContractorResponse>(url, finalData, config);
};

export const requestDeleteSubcontractor = (
  { email, subContractorId }: { email: string; subContractorId: string },
  config?: AxiosRequestConfig,
) =>
  http.delete(
    getDeleteContractorEndpoint,
    { subContractorId, email },
    config,
    undefined,
    undefined,
    false,
  );

export const requestSubcontractorsList = (
  { email }: { email: string },
  config?: AxiosRequestConfig,
) => {
  return http.get<SubContractorsFlatResponse>(
    getSubContractorsEndpoint,
    { email },
    config,
    undefined,
    SubContractorsResponseSchema,
  );
};

export const requestSearchSubcontractors = (
  { email, search }: { email: string; search: string },
  config?: AxiosRequestConfig,
) =>
  http.get<SubContractorsSearchResponse>(
    getSubContractorByNameEndpoint,
    { name: search, email },
    config,
    undefined,
    SubContractorsSearchResponseSchema,
    false,
  );

export const requestAddSubcontractor = (
  email: QueryParamsForGetRequest,
  data: AddSubContractorPayload,
  currentUserContractorId: string | number,
  config?: AxiosRequestConfig,
) => {
  const url = appendQueryToUrl(getAddContractorEndpoint, email);

  const finalData: AddSubContractorPayload = {
    ...data,
    AdcciMembershipNo: data.AdcciMembershipNo || null,
    CicpaId: data.CicpaId ?? 0,
    ContractorId: currentUserContractorId,
    CompanyNameEn: undefined,
    CompanyNameAr: undefined,
    SubContractorNameEn: data.CompanyNameEn ?? "",
    SubContractorNameAr: data.CompanyNameAr ?? "",
    TradeLicenseNumber:
      data.TradeLicenseNumber || data.AdcciMembershipNo?.toString() || "",
    TradeLicenseExpiryDate:
      data.TradeLicenseExpiryDate || data.InsuranceExpiryDate || "",
    TradeLicenseDocument: {
      ...data.TradeLicenseDocument,
      DocNameEn: data.TradeLicenseDocument?.DocNameEn ?? "",
      FileBase64: data.TradeLicenseDocument?.FileBase64 ?? "",
    },
  };

  return http.post<AddSubContractorResponse>(url, { ...finalData }, config);
};
